import { Fragment, useEffect, useState } from '@wordpress/element';
import { dispatch, withSelect } from '@wordpress/data';
import { compose } from '@wordpress/compose';;
import { BaseControl, PanelBody, panelRow, Button, TextControl, SelectControl, ToggleControl, ToolbarGroup, ToolbarButton, __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { useBlockProps, InspectorControls, InnerBlocks, RichText, BlockControls, ColorPalette } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { createBlock } from '@wordpress/blocks';

import { AnimateTrack } from './Components/Superblockslider'

import './Components/slide';

const ALLOWED_BLOCKS = [
	['superblockslider/slide', {}],
	['superblockslider/video', {}]
];
const ENABLE_ON_BLOCKS = [
	'superblockslider/slider'
]

import './editor.scss';

export default function Edit(props) {
	return <SlidesComponent {...props} />;
}

const SlidesComponentBase = ({ block, props }) => {
	const {
		attributes: {
			slides,
			initialActiveSlideValue,
			transitionSpeedValue,
			transitionAnimationValue,
			autoplayValue,
			autoplayIntervalValue,
			loopSlideValue,
			slideNavigationValue,
			hoverPauseValue,
			arrowNavigationValue,
			navigationColorValue,
			sliderHeightValue,
			sliderWidthValue,
			transitionEffectValue,
		},
		setAttributes,
		clientId,
	} = props

	const [getCurrentSlideIndex, setCurrentSlideIndex] = useState(initialActiveSlideValue);
	const [getInnerBlockCount, setInnerBlockCount] = useState(slides.length);

	let sliderTrackWidth = block.innerBlocks.length * 100
	const offsetPercent = 100 / block.innerBlocks.length;
	const translateX = offsetPercent * getCurrentSlideIndex
	let trackTranslateX = `translateX(-${translateX}%)`;

	let slideTrackStyle = {
		width: `${sliderTrackWidth}%`,
		transform: trackTranslateX,
		transitionDuration: transitionSpeedValue,
		transitionTimingFunction: transitionAnimationValue,
	}
	if(transitionEffectValue == 'fade') {
		slideTrackStyle = {}
	}
	// console.log(slideTrackStyle)

	const blockProps = useBlockProps();

	let el_SlidesComponent = document.getElementById("block-" + clientId)
	/**
	 * editor interactive code
	 */
	useEffect(() => {
		if (!block.innerBlocks.length) {
			addSlideButtonOnClick()
		}
	}, []);


	let blockList = wp.data.select('core/block-editor').getBlock(props.clientId).innerBlocks.length
	wp.data.subscribe(() => {
		const getBlockList = wp.data.select('core/block-editor').getBlock(props.clientId)
		if(getBlockList) {
			const newBlockList = getBlockList.innerBlocks.length
			const blockListChanged = newBlockList !== blockList
			blockList = newBlockList
			if ( blockListChanged ) {
				setCurrentSlideIndex(blockList-1)
				AnimateTrack(blockList-1, blockList, el_SlidesComponent, transitionEffectValue)
			}
		}
	});

	/**
	 * set current selected slide to active when selected in editor
	 */
	if(el_SlidesComponent) {
		if(el_SlidesComponent.querySelectorAll('.superblockslider__slide')[getCurrentSlideIndex]) {
			el_SlidesComponent.querySelectorAll('.superblockslider__slide')[getCurrentSlideIndex].classList.add('superblockslider__slide--active')
		}
	}
	
	/**
	 * Button click event : Create a new block
	 * @param {event} event 
	 */
	const addSlideButtonOnClick = (event) => {
		const newSlide = createBlock('superblockslider/slide', {})
		dispatch('core/block-editor').insertBlock(newSlide, block.innerBlocks.length, clientId)
		// .then((data)=> {
		// 	console.log(data.index)
		// 	slideFunction(data.index)
		// })
		
	}

	/**
	 * Click slide button
	 * @param {event} event 
	 */
	const slideButtonOnClick = (event) => {
		const target = event.currentTarget;
		const buttonDataId = parseInt(target.getAttribute('data-slide-id'))
		slideFunction(buttonDataId)
	}
	/**
	 * Prev arrow click
	 * @param {event} event 
	 */
	 const prevButtonOnClick = (event) => {
		let currentSlideId = getCurrentSlideIndex - 1
		currentSlideId < 0 ? currentSlideId = 0 : null;
		slideFunction(currentSlideId)
	}
	/**
	 * Next arrow on click
	 * @param {event} event 
	 */
	const nextButtonOnClick = (event) => {
		let currentSlideId = getCurrentSlideIndex + 1
		currentSlideId + 1 > block.innerBlocks.length ? currentSlideId = block.innerBlocks.length - 1 : null;
		slideFunction(currentSlideId)
	}
	/**
	 * 
	 * @param {integer} slideIndex 
	 */
	const slideFunction = (slideIndex) => {
		setCurrentSlideIndex(slideIndex)
		AnimateTrack(slideIndex, block.innerBlocks.length, el_SlidesComponent, transitionEffectValue)
	}

	/**
	 * set first created innerBlock to initial Active Slide
	 */
	if (block.innerBlocks.length && block.innerBlocks.length == 1 && block.innerBlocks[0].attributes.isActiveSlide == false) {
		// console.log(block.innerBlocks)
		dispatch('core/block-editor').updateBlockAttributes(block.innerBlocks[0].clientId, { isActiveSlide: true })
		.then(()=> {
			slideFunction(0)
		})
	}

	/**
	 * 
	 * Check current block slide index greater then slide count, select last slide 
	 */
	if(block.innerBlocks.length && getCurrentSlideIndex > block.innerBlocks.length - 1) {
		let currentSlideId = getCurrentSlideIndex - 1
		currentSlideId < 0 ? currentSlideId = 0 : null;
		AnimateTrack(currentSlideId, block.innerBlocks.length, el_SlidesComponent, transitionEffectValue)
		setCurrentSlideIndex(currentSlideId)
	}
	/**
	 * set initial Active Slide to 0 if initialActiveSlideValue is greater than slide count
	 */
	if (block.innerBlocks.length && initialActiveSlideValue > block.innerBlocks.length - 1) {
		setAttributes({
			initialActiveSlideValue: 0,
		});
		
	}
	/**
	 * NEED CLEAN UP
	 * new innerBlock data
	 */
	
	if (block.innerBlocks.length != slides.length) {
		const slidesNew = []
		block.innerBlocks.forEach((item, index) => {
			slidesNew[index] = item.attributes.slideTitle;
		});
		setAttributes({
			slides: slidesNew,
		});
		

		// const superblockslider__track = document.getElementsByClassName('superblockslider__track')[0]

		// if (superblockslider__track && superblockslider__track.length) {
		// 	/**
		// 	 * set slide track to last slide position
		// 	 */
		// 	// run on new thread to apply move translateX
		// 	setTimeout (() => {
		// 		const lastSlidePosition = getCurrentSlideIndex - 1 * offsetPercent;
		// 		superblockslider__track.style.transform = `translateX(-${lastSlidePosition}%)`
		// 	}, 200);
		// }
	}

	/**
	 * detect inner block changes
	 */
	// if ( getInnerBlockCount != slides.length ) {
	// 	setInnerBlockCount(slides.length)
	// 	if(slides.length > getInnerBlockCount) {
	// 		slideFunction(slides.length)
	// 	}
	// 	else {
	// 		slideFunction(slides.length - 1)
	// 	}
	// }

	/**
	 * 
	 * @param {int} initialActiveSlideValueNew 
	 */
	const initialActiveSlideValueOnChange = (initialActiveSlideValueNew) => {
		setAttributes({ initialActiveSlideValue: parseInt(initialActiveSlideValueNew) })
		slideFunction(initialActiveSlideValueNew)
	}
	/**
	 * Transition animation speed
	 * @param {string} transitionSpeedValueNew 
	 */
	const transitionSpeedValueOnChange = (transitionSpeedValueNew) => {
		setAttributes({ transitionSpeedValue: transitionSpeedValueNew })
	}
	/**
	 * Transition animation
	 * @param {string} transitionAnimationValueNew 
	 */
	const transitionAnimationValueOnChange = (transitionAnimationValueNew) => {
		setAttributes({ transitionAnimationValue: transitionAnimationValueNew })
	}
	const autoplayValueOnChange = (autoplayValueNew) => {
		setAttributes({ autoplayValue: autoplayValueNew })
	}
	const autoplayIntervalValueOnChange = (autoplayIntervalValueNew) => {
		setAttributes({ autoplayIntervalValue: autoplayIntervalValueNew })
	}
	/**
	 * Infinite slide
	 * @param {boolean} loopSlideValueNew 
	 */
	const loopSlideValueOnChange = (loopSlideValueNew) => {
		setAttributes({ loopSlideValue: loopSlideValueNew })
	}
	const slideNavigationValueOnChange = (slideNavigationValueNew) => {
		setAttributes({ slideNavigationValue: slideNavigationValueNew })
	}
	const hoverPauseValueOnChange = (hoverPauseValueNew) => {
		setAttributes({ hoverPauseValue: hoverPauseValueNew })
	}
	const arrowNavigationValueOnChange = (arrowNavigationValueNew) => {
		setAttributes({ arrowNavigationValue: arrowNavigationValueNew })
	}
	const navigationColorValueOnChange = (navigationColorValueNew) => {
		setAttributes({ navigationColorValue: navigationColorValueNew })
	}
	const sliderHeightValueOnChange = (sliderHeightValueNew) => {
		setAttributes({ sliderHeightValue: sliderHeightValueNew })
	}
	const sliderWidthValueOnChange = (sliderWidthValueNew) => {
		setAttributes({ sliderWidthValue: sliderWidthValueNew })
	}
	const transitionEffectValueOnChange = (transitionEffectValueNew) => {
		if(transitionEffectValueNew == 'fade') {
			slideTrackStyle = {}
		}
		setAttributes({ transitionEffectValue: transitionEffectValueNew })
	}

	/**
	 * No slide
	 */
	if (!block.innerBlocks.length) {
		return (
			<div {...blockProps} >
				<p>Add a slide</p>
				<InnerBlocks allowedBlocks={ALLOWED_BLOCKS} templateLock={false} />
			</div>
		)
	}

	const navigationSvgStyle = navigationColorValue ? {fill : navigationColorValue} : {}
	const navigationCssStyle = navigationColorValue ? {color : navigationColorValue} : {}

	let extraClass = [
		];

	extraClass = extraClass.filter(Boolean).join(' ');

	return [
		<div {...blockProps} style={{
			height: sliderHeightValue,
			width: sliderWidthValue,
			}}
			data-transition-effect={transitionEffectValue}
		>

			<div className="superblockslider__window">

				<div className="superblockslider__track"
					style={slideTrackStyle}
				>
					<InnerBlocks allowedBlocks={ALLOWED_BLOCKS} templateLock={false} orientation="horizontal" renderAppender={false} />
				</div>

			</div>
			{slideNavigationValue != 'none' &&
				<div className="superblockslider__controls superblockslider__buttons">
					{block.innerBlocks.map((slide, index) => {
						let buttonContent

						if(slideNavigationValue == 'dots') {
							buttonContent = <button data-slide-id={index}>
								<span className='superblockslider__button__icon'>
									<svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' style={navigationSvgStyle}>
										<path d='M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zM10 15c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z'/>
									</svg>
								</span>
							</button>
						}
						else if(slideNavigationValue == 'title') {
							buttonContent = <button data-slide-id={index}>
								<RichText
									tagName="div"
									style={navigationCssStyle}
									value={slide.attributes.slideTitle}
									onChange={
										(slideTitleNew) => {
											/**
											 * update slides[index] title
											 */
											const slidesCopy = [...slides]
											slidesCopy[index] = slideTitleNew
											setAttributes({ slides: slidesCopy });
											/**
											 * update slide component
											 */
											dispatch('core/block-editor').updateBlockAttributes(slide.clientId, { slideTitle: slideTitleNew })
										}
									}
									multiline={false}
									preserveWhiteSpace={false}
								/>
							</button>
						}
						

						return (
							<div className={initialActiveSlideValue != index ? 'superblockslider__button' : 'superblockslider__button superblockslider__button--active'} onClick=				{slideButtonOnClick} data-slide-id={index}>
								
								{buttonContent}
							</div>
						);

					})}
				</div>
			}
			{arrowNavigationValue && 
				<div className="superblockslider__controls superblockslider__navigation">
					<button
						className="superblockslider__button__navigation superblockslider__button__previous"
						aria-label="Previous slide"
						onClick={prevButtonOnClick}
					>
						<span className="superblockslider__button__previous--icon">
							<svg width="85" height="85" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85 85" role="img" aria-hidden="true" focusable="false"><path d="M58.3,21.7l-5-4.2l-22.5,25l22.5,25l5-4.2L39.2,42.5L58.3,21.7z" style={navigationSvgStyle}></path></svg>
						</span>
					</button>

					<button
						className="superblockslider__button__navigation superblockslider__button__next"
						aria-label="Next slide"
						onClick={nextButtonOnClick}
					>
						<span className="superblockslider__button__next--icon">
							<svg width="85" height="85" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85 85" role="img" aria-hidden="true" focusable="false"><path d="M31.7,17.5l-5,4.2l19.2,20.8L26.7,63.3l5,4.2l22.5-25L31.7,17.5z" style={navigationSvgStyle}></path></svg>
						</span>
					</button>
				</div>
			}

		</div>,

		<BlockControls>
			<ToolbarGroup>
				<ToolbarButton
					icon='table-row-after'
					label="Add new slide"
					onClick={addSlideButtonOnClick}
				>Add new slide</ToolbarButton>
			</ToolbarGroup>
		</BlockControls>,

		<InspectorControls>

			<PanelBody>
				<panelRow>
					<Button isSecondary={true} onClick={addSlideButtonOnClick} label="Add new slide" icon='table-row-after'>
						Add new slide
					</Button>
				</panelRow>
			</PanelBody>

			<PanelBody title={__('Best WP Slider settings')} initialOpen={true} >

				<SelectControl
					label={__('Initial selected slide')}
					help='Set first selected slide.'
					value={parseInt(initialActiveSlideValue)}
					options={
						block.innerBlocks.map((slide, index) => {
							const labelValue = slideNavigationValue == 'title' ? `#${index + 1} - ${slide.attributes.slideTitle}` : `#${index + 1}`
							return (
								{
									label: labelValue,
									value: parseInt(index)
								}
							)
						})
					}
					onChange={initialActiveSlideValueOnChange}
					className="inline-field-control"
				/>

				<SelectControl
					label={__('Transition effect')}
					value={transitionEffectValue}
					options={[
						{ label: 'Slide', value: 'slide' },
						{ label: 'Fade', value: 'fade' },
					]}
					onChange={transitionEffectValueOnChange}
					className="inline-field-control"
				/>

				<BaseControl
					label={__("Transition animation speed")}
					help={__('Transintion animation speed. In seconds or milliseconds. e.g. 1.5s, 1500ms')}
				>
					<TextControl
						placeholder={__('e.g. 1.5s, 1500ms')}
						value={transitionSpeedValue}
						onChange={transitionSpeedValueOnChange}
					/>
				</BaseControl>

				<SelectControl
					label={__('Transition animation')}
					help={__('Speed curve of the transition.')}
					className="inline-field-control"
					value={transitionAnimationValue}
					options={[
						{ label: 'Ease', value: 'ease' },
						{ label: 'Linear', value: 'linear' },
						{ label: 'Ease-in', value: 'ease-in' },
						{ label: 'Ease-out', value: 'ease-out' },
						{ label: 'Ease-in-out', value: 'ease-in-out' },

						{ label: '', value: null, disabled: true },
						{ label: 'Sine', value: null, disabled: true },

						{ label: 'In · Sine', value: 'cubic-bezier(0.47, 0, 0.75, 0.72)' },
						{ label: 'In Out · Sine', value: 'cubic-bezier(0.45, 0.05, 0.55, 0.95)' },
						{ label: 'Out · Sine', value: 'cubic-bezier(0.39, 0.58, 0.57, 1)' },

						{ label: '', value: null, disabled: true },
						{ label: 'Cubic', value: null, disabled: true },

						{ label: 'In · Cubic', value: 'cubic-bezier(0.55, 0.06, 0.68, 0.19)' },
						{ label: 'In Out · Cubic', value: 'cubic-bezier(0.65, 0.05, 0.36, 1)' },
						{ label: 'Out · Cubic', value: 'cubic-bezier(0.22, 0.61, 0.36, 1)' },

						{ label: '', value: null, disabled: true },
						{ label: 'Quadratic', value: null, disabled: true },

						{ label: 'In · Quadratic', value: 'cubic-bezier(0.55, 0.09, 0.68, 0.53)' },
						{ label: 'In Out · Quadratic', value: 'cubic-bezier(0.46, 0.03, 0.52, 0.96)' },
						{ label: 'Out · Quadratic', value: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' },

						{ label: '', value: null, disabled: true },
						{ label: 'Back', value: null, disabled: true },

						{ label: 'In Out · Back', value: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)' },
						{ label: 'In · Back', value: 'cubic-bezier(0.6, -0.28, 0.74, 0.05)' },
						{ label: 'Out · Back', value: 'cubic-bezier(0.18, 0.89, 0.32, 1.28)' },

						{ label: '', value: null, disabled: true },
						{ label: 'Other', value: null, disabled: true },

						{ label: 'Linear In, Fast Out', value: 'cubic-bezier(0.4, 0, 1, 1)' },
						{ label: 'Slow In, Fast Out', value: 'cubic-bezier(0.4, 0, 0.2, 1)' },
						{ label: 'Slow In, Linear Out', value: 'cubic-bezier(0, 0, 0.2, 1)' },
					]}
					onChange={transitionAnimationValueOnChange}
				/>

				<ToggleControl
					label={__('Autoplay')}
					help={__("Auto rotate to next slide.")}
					checked={autoplayValue}
					onChange={autoplayValueOnChange}
				/>

				{autoplayValue &&
					<Fragment>

						<ToggleControl
							label={__('Stop autoplay mouse over')}
							help={__("Pause when mouse cursor is over slider.")}
							checked={hoverPauseValue}
							onChange={hoverPauseValueOnChange}
						/>

						<BaseControl
							label="Autoplay timing"
							help={__('Interval between slides. In seconds or milliseconds. e.g. 1.5s, 1500ms')}
							>
							<TextControl
								placeholder={__('e.g. 1.5s, 1500ms')}
								value={autoplayIntervalValue}
								onChange={autoplayIntervalValueOnChange}
								/>
						</BaseControl>

					</Fragment>
				}

				<ToggleControl
				label='loop slides'
				help="Note: No preview in editor."
				checked={transitionEffectValue == 'slide' ? loopSlideValue : true}
				onChange={loopSlideValueOnChange}
				disabled={transitionEffectValue != 'fade' ? false : true}
				/>

				<ToggleControl
					label='Show arrows'
					help="Visibility of previous and next arrows."
					checked={arrowNavigationValue}
					onChange={arrowNavigationValueOnChange}
				/>

				<SelectControl
					label={__('Slide indicator')}
					value={slideNavigationValue}
					options={[
						{ label: 'None', value: 'none' },
						{ label: 'Dots', value: 'dots' },
						{ label: 'Title', value: 'title' },
					]}
					onChange={slideNavigationValueOnChange}
				/>

				<BaseControl
					label='Navigation color'
					help={__('Color of arrows, dots, and titles.')}
				>
					<ColorPalette
						value={ navigationColorValue }
						onChange={ navigationColorValueOnChange }
					/>
				</BaseControl>

				<UnitControl
					label='Height of slider'
					value={sliderHeightValue}
					style={{maxWidth: '100px'}}
					help='Height'
					onChange={sliderHeightValueOnChange}
				/>
				<UnitControl
					label='Width of slider'
					value={sliderWidthValue}
					style={{maxWidth: '100px'}}
					help='Height'
					onChange={sliderWidthValueOnChange}
				/>
				
			</PanelBody>

		</InspectorControls>
	];
}
const applyWithSelect = withSelect((select, props) => {
	const { getBlock } = select('core/block-editor');
	return { block: getBlock(props.clientId), props };
});

const SlidesComponent = compose(
	applyWithSelect,
)(SlidesComponentBase);

